var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScHomeNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    y: 0.500244,
    width: 38,
    height: 37.9994,
    rx: 18.9997,
    fill: "#FF7D19"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5274_2717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8482 14.7196L31.7148 21.2353L31.6509 23.251C31.6509 23.251 8.05397 24.0389 7.01074 23.755L7.67075 14.4712L9.58689 14.8474L11.6024 16.7637L16.6979 16.0114L18.8482 14.7196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7289 20.132L18.6643 14.1842C18.4443 14.0777 18.1746 14.1416 18.0398 14.3474C17.5288 15.0856 16.4075 15.9799 13.9591 16.1147C12.4901 16.1928 10.9501 15.916 10.7301 15.5327C10.0204 14.1061 8.82814 13.8222 8.03329 14.0138C7.19587 14.2126 6.64941 14.8939 6.64941 15.7528V23.5105C6.64941 23.9009 6.96877 24.2203 7.3591 24.2203H30.516C31.5237 24.2203 32.3612 23.617 32.5528 22.7582C32.6238 22.382 32.7373 21.0831 30.7289 20.132ZM27.9895 19.8552C28.5218 20.1391 29.1818 20.4869 30.0973 20.9412C30.1966 20.9908 30.1612 21.1399 30.0476 21.1399H20.0198C19.9488 21.1399 19.8992 21.076 19.9134 21.0121C20.1901 19.8055 21.2334 18.9254 22.383 18.9254C23.036 18.9254 23.5682 18.9183 24.0011 18.9112C26.1586 18.8899 26.1586 18.8899 27.9895 19.8552ZM7.69974 15.7528C7.69974 15.3056 7.95523 15.0075 8.37394 14.9507C8.92749 14.8797 9.63717 15.2417 9.82169 15.9089C9.93524 16.2993 10.4959 16.6471 11.3546 16.8671C13.5972 17.442 17.025 17.0445 18.6643 15.405L18.7211 15.3482L23.625 17.7543C23.7243 17.804 23.6889 17.953 23.5753 17.953C21.4818 17.953 19.2959 18.3221 18.9411 21.0476L18.9269 21.1399H12.9088C12.852 21.1399 12.8094 21.0973 12.8024 21.0476C12.7172 19.912 12.1069 18.8331 11.1204 18.0808C10.1339 17.3284 8.93459 17.0161 7.82749 17.2291C7.76361 17.2433 7.69974 17.1936 7.69974 17.1226V15.7528ZM7.70684 18.2227L7.7849 18.2015C8.50878 17.9956 9.48104 18.1873 10.2688 18.6841C11.1204 19.2235 11.674 20.0469 11.8372 21.0192C11.8514 21.0831 11.8017 21.1399 11.7307 21.1399H7.71394C7.65716 21.1399 7.60748 21.0902 7.60748 21.0334L7.70684 18.2227ZM31.6089 22.2329C31.6089 22.24 31.4954 23.2408 30.5018 23.2408H7.72103C7.66426 23.2408 7.61458 23.1911 7.61458 23.1343V22.2258C7.61458 22.1691 7.66426 22.1194 7.72103 22.1194H31.5096C31.5663 22.1194 31.616 22.1691 31.6089 22.2329Z",
    fill: "#291482"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5274_2717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6,
    height: 26.5996,
    fill: "white",
    transform: "translate(6.23926 6.2002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScHomeNewIcon);
export default __webpack_public_path__ + "static/media/sc-home-new-icon.a11e6b4709a9f0cece707b6a13292cb8.svg";
export { ForwardRef as ReactComponent };